import styled from "styled-components";
import { device } from "../device"
import sunIcon from '../assets/images/sun-icon.png';
import houseLogo from '../assets/images/house.png';
import rainbowIcon from '../assets/images/rainbow-icon.png';
import manchaLaranja from '../assets/images/mancha-laranja.png';
import manchaAmarela from '../assets/images/mancha--amarela.png';

export const Container = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-top: 15px;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  position: relative;
  z-index: 2;
  width: 80%;
  margin-bottom: 60px;
`;

export const WhiteWrapper = styled(Wrapper)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 0px 18px rgba(0, 0, 0, 0.25);
  padding: 20px;
  padding-bottom: 40px;
`;

export const Title = styled.h1`
  display: flex;
  justify-content: center;
  text-align: center;
  font-family: 'Quicksand', sans-serif;
  font-size: 25px;
  margin-bottom: 0px;
  margin-top: 0px;
  color: ${({ theme }) =>  theme.colors.darkPrimary};

  @media ${device.tablet} {
    font-size: 60px;
  }

  @media ${device.desktop} {
    font-size: 100px;
  }
`;

export const SubTitle = styled(Title)`
  margin-top: 10px;
  margin-bottom: 40px;
  font-size: 15px;

  @media ${device.tablet} {
    font-size: 36px;
  }

  @media ${device.desktop} {
    font-size: 70px;
  }
`;

export const Information = styled.p`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  text-align: justify;
  color: ${({ theme }) =>  theme.colors.darkPrimary};
  margin: 0;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 18px;
    width: 80%;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }

  @media ${device.laptopM} {
    font-size: 18px;
    line-height: 32px;
    width: 80%;
  }

  @media ${device.desktop} {
    font-size: 30px;
    line-height: 50px;
  }
`;

export const SunIcon = styled.div `
  background-image: url(${sunIcon});
  background-repeat: no-repeat;
  background-size: contain;
  width: 129px;
  height: 134px;
  align-self: baseline;
  z-index: 1;
  position: absolute;
  bottom: -2px;
  right: -33px;
  opacity: 0.5;
  transform: rotate(-90deg);
`;
export const HouseLogo = styled.div `
  display: none;

  @media ${device.tablet} {
    display: block;
    background-image: url(${houseLogo});
    background-repeat: no-repeat;
    background-size: contain;
    opacity: .6;
    width: 153px;
    height: 88px;
    align-self: baseline;
    position: absolute;
    bottom: 0;
    left: 0;
    margin-bottom: 22px;
    margin-left: 13px;
    z-index: 0;
  }
`;
export const RainbowIcon = styled.div `
  background-image: url(${rainbowIcon});
  background-repeat: no-repeat;
  background-size: contain;
  opacity: .6;
  width: 153px;
  height: 88px;
  align-self: baseline;
  position: absolute;
  bottom: -12px;
  left: 0;
  z-index: 0;

  @media ${device.tablet} {

  }
`;

export const ManchaLaranja = styled.div `
  background-image: url(${manchaLaranja});
  background-repeat: no-repeat;
  background-size: contain;
  opacity: .4;
  width: 153px;
  height: 88px;
  align-self: baseline;
  position: absolute;
  bottom: -2px;
  left: -5px;
  z-index: 0;
  transform: rotate(15deg);

  @media ${device.laptopM} {
    bottom: 10px;
    left: 10px;
  }
`;
export const ManchaAmarela = styled.div `
  background-image: url(${manchaAmarela});
  background-repeat: no-repeat;
  background-size: contain;
  opacity: .6;
  width: 153px;
  height: 88px;
  align-self: baseline;
  position: absolute;
  bottom: 0;
  left: 1px;
  z-index: 0;

  @media ${device.tablet} {

  }
`;
